export default "__VITE_ASSET__BNvebvdh__"